module.exports = __webpack_public_path__ + "img/minus-square.030123c7.svg";